const svgPathMapping: any = {
  ORDER_STATUS: '/media/icons/duotune/FlagActivity.svg',
  MESSAGE: '/media/icons/duotune/Message.svg',
  TASK: '/media/icons/duotune/Task.svg'
};

export { svgPathMapping };
